module.exports = __webpack_public_path__ + "img/logo_espace_client_ubiflow_fr@2x.ce1cd28f.png";